// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.
/**
 * Models for communities operations
 */
import type * as Schemas from '../schemas.js';





/**
 * Response for search
 * 
 * @public
 */
export type SearchResponse = Schemas.Get2CommunitiesSearchResponse;
/**
 * Response for getById
 * 
 * @public
 */
export type GetByIdResponse = Schemas.Get2CommunitiesIdResponse;